function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import ViewportObserver from './ViewportObserver';

var WpCounterBlock = /*#__PURE__*/function () {
  function WpCounterBlock() {
    _classCallCheck(this, WpCounterBlock);

    this.selBase = 'wp-block-acf-counter';
    this.counters = Array.from(document.querySelectorAll(".".concat(this.selBase, "__num")));
    if (!this.counters || this.counters.length === 0) return;
    this.resetNumbers();
    this.bindObserver();
  }

  _createClass(WpCounterBlock, [{
    key: "resetNumbers",
    value: function resetNumbers() {
      this.counters.forEach(function (counter) {
        return counter.textContent = counter.dataset.counterFrom;
      });
    }
  }, {
    key: "bindObserver",
    value: function bindObserver() {
      var observer = new ViewportObserver(".".concat(this.selBase, "__num"), {
        threshold: '25%',
        onEnter: this.handleEnter.bind(this),
        onExit: this.handleExit.bind(this)
      });
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(entry, observer) {
      var from = parseFloat(entry.target.dataset.counterFrom);
      var to = parseFloat(entry.target.dataset.counterTo);
      var ms = Math.abs(650 / (to - from));
      var handler = setInterval(function () {
        if (from >= to) {
          clearInterval(handler);
        }

        entry.target.textContent = from;
        from += from < to ? 1 : -1;
      }, ms);
      console.log('enter', entry);
    }
  }, {
    key: "handleExit",
    value: function handleExit(entry, observer) {
      console.log('exit', entry);

      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
      }
    }
  }]);

  return WpCounterBlock;
}();

export { WpCounterBlock as default };